  import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PatientService } from 'src/app/admin/services/patient.service';
import { SideNavService } from 'src/app/admin/services/side-nav.service';

@Component({
  selector: 'app-search-patient',
  templateUrl: './search-patient.component.html',
  styleUrls: ['./search-patient.component.scss']
})
export class SearchPatientComponent implements OnInit {
  loading = false;
  searchPatientForm: UntypedFormGroup;
  noResults = false;
  constructor(private fb: UntypedFormBuilder, private patientService: PatientService, private sideNavService: SideNavService) { }

  ngOnInit(): void {
      this.searchPatientForm = this.fb.group(
        {
          name: [''],
          surname: [''],
          mobile: [''],
          email: ['']
      });
  }
  search(){
    this.noResults = false;
    this.loading = true;
    this.patientService.searchPatient(this.searchPatientForm.value).then(res => {
      if(res.length > 0){
        this.patientService.patients.next(res);
        this.sideNavService.close();
      } else {
        this.noResults = true;
      }
      this.loading = false;
    })
  }
}
